<template>
  <FootnoteEditor
    :is-expanded="isExpanded"
    :text="item?.footnote_text || ''"
    :custom-char="item?.custom_footnote_char || ''"
    :on-amount="!!item?.footnote_on_amount"
    v-bind="$attrs"
    @update:text="$emit('update', { footnote_text: $event })"
    @update:custom-char="$emit('update', { custom_footnote_char: $event })"
    @update:on-amount="$emit('update', { footnote_on_amount: $event })"
  />
</template>

<script setup>
  import { computed } from "vue";
  import FootnoteEditor from "./footnote-editor.vue";

  const props = defineProps({
    item: { type: Object, default: () => ({}) },
  });

  defineEmits(["update"]);

  const isExpanded = computed(() => {
    return (
      !!props.item?.footnote_text ||
      !!props.item?.custom_footnote_char ||
      !!props.item?.footnote_on_amount
    );
  });
</script>
